import {
    DataReceiptForm,
    DataReceivedStatus,
    ReceiptDetailDto,
    ReceiptShippingInfoDto,
    ReceiptShippingInfoWrapper,
} from "../models/DataReceipt"
import { TimeUtils } from "./TimeUtils"

export const transformShippingInfoDtoToSelectedShippingInfo = (
    shippingInfo: ReceiptShippingInfoDto,
    feId: number,
): ReceiptShippingInfoWrapper => {
    return {
        fe_id: feId,
        shipping_info: shippingInfo,
        mission: shippingInfo.mission,
        detail: {
            // Will not have an ID at this point since being created on the frontend
            size_in_gb: shippingInfo.raw_storage_size_gb,
            status: DataReceivedStatus.RECEIVED,
            notes: "",
        },
    }
}

export const transformShippingInfoToReceiptDetailDto = (
    shippingInfoWrapper: ReceiptShippingInfoWrapper,
): ReceiptDetailDto => {
    const shippingInfo = shippingInfoWrapper.shipping_info
    return {
        id: shippingInfoWrapper.detail.id,
        mission_shipping_info_id: shippingInfo.id,
        notes: shippingInfoWrapper.detail.notes,
        status: shippingInfoWrapper.detail.status,
        size_in_gb: shippingInfoWrapper.detail.size_in_gb,
    }
}

export const isValidDataReceipt = (
    formDetails: DataReceiptForm,
    selectedShippingInfo: ReceiptShippingInfoWrapper[],
) => {
    const validForm =
        formDetails.office != null &&
        formDetails.date_received !== "" &&
        formDetails.date_received !== TimeUtils.invalidDate &&
        formDetails.received_by != null
    return selectedShippingInfo.length > 0 && validForm
}
